import { Component } from '@angular/core';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';
import { OAuthService } from '../../../../../../../services/oauth.service';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';

@Component({
    selector: 'googleads-connector-panel',
    templateUrl: './google.ads.connector.panel.html'
})
export class GoogleAdsConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Google Ads',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.GoogleAdsInfo',
            ControlType: GoogleAdsConnectorPanel,
            Default: null
        };
    }

    constructor(private service: OAuthService) {
        super();
    }

    authenticate() {
        if (this.DataSource && this.DataSource.SID) {
            this.service.GetOAuthURL(this.DataSource.SID, "CData").subscribe(x => {
                if (x) {
                    window.open(x, '_blank');
                }
            });
        }
    }
}